var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { Form } from "react-final-form";
/**  our default final-form subscription for Quinine is just enough to allow Submit buttons to react to changes, preventing the entire form from rerendering if a single field changes.
 Note: `values` is not part of the default, if you need to write validators that reference multiple field values, set `values: true`*/
export const defaultSubscription = {
    dirty: true,
    submitting: true,
    hasValidationErrors: true,
};
export function QuiForm(_a) {
    var { subscription, children, onSubmit, className, style } = _a, otherProps = __rest(_a, ["subscription", "children", "onSubmit", "className", "style"]);
    // avoiding use of Omit type here because it causes problems with type inference on available form props
    if (otherProps.component || otherProps.render) {
        throw new Error("QuiForm does not support the `component` or `render` props.");
    }
    return (React.createElement(Form, Object.assign({ subscription: subscription !== null && subscription !== void 0 ? subscription : defaultSubscription, onSubmit: onSubmit, render: ({ handleSubmit }) => (React.createElement("form", { className: className, onSubmit: handleSubmit, style: style }, children)) }, otherProps)));
}
